import i18n from '@/i18n'

const header = [
	{
		'name': i18n.t('point_store.menu.goods'),
		'id': 0,
		'isActive': false
	},
	{
		'name': i18n.t('point_store.menu.detail'),
		'id': 1,
		'isActive': false
	},
	{
		'name': i18n.t('point_store.menu.record'),
		'id': 2,
		'isActive': false
	}
];


export {
	header,
}
